/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignCounselorRequest
 */
export interface AssignCounselorRequest {
    /**
     * 
     * @type {string}
     * @memberof AssignCounselorRequest
     */
    assignedCounselorId?: string | null;
}

/**
 * Check if a given object implements the AssignCounselorRequest interface.
 */
export function instanceOfAssignCounselorRequest(value: object): value is AssignCounselorRequest {
    return true;
}

export function AssignCounselorRequestFromJSON(json: any): AssignCounselorRequest {
    return AssignCounselorRequestFromJSONTyped(json, false);
}

export function AssignCounselorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignCounselorRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'assignedCounselorId': json['assignedCounselorId'] == null ? undefined : json['assignedCounselorId'],
    };
}

export function AssignCounselorRequestToJSON(json: any): AssignCounselorRequest {
    return AssignCounselorRequestToJSONTyped(json, false);
}

export function AssignCounselorRequestToJSONTyped(value?: AssignCounselorRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assignedCounselorId': value['assignedCounselorId'],
    };
}

